// extracted by mini-css-extract-plugin
export default {"pin-switches":"PinOutputList_pin-switches__FxHc3"};